import { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from 'components/ui/dialog';
import { Button } from 'components/ui/button';
import { Textarea } from 'components/ui/textarea';
import { Label } from 'components/ui/label';

interface Props {
  isOpen: boolean;
  ticketId: number;
  onClose: () => void;
  onConfirm: (reason: string) => Promise<void>;
}

export function ReopenReasonModal({ isOpen, ticketId, onClose, onConfirm }: Props) {
  const [reason, setReason] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleConfirm = async () => {
    if (!reason.trim()) return;
    setIsSubmitting(true);
    try {
      await onConfirm(reason.trim());
      setReason('');
      onClose();
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    if (isSubmitting) return;
    setReason('');
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={(o) => !o && handleClose()}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Ticket RT-{ticketId} heropenen</DialogTitle>
        </DialogHeader>

        <div className="space-y-3">
          <p className="text-sm text-gray-600">
            Geef een reden op voor het heropenen van dit ticket. Deze reden wordt als actienota opgeslagen.
          </p>
          <div className="space-y-1">
            <Label htmlFor="reopen-reason">Reden *</Label>
            <Textarea
              id="reopen-reason"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Bijv: Leverancier heeft gemeld dat de werken niet correct zijn uitgevoerd..."
              rows={4}
              autoFocus
            />
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={handleClose} disabled={isSubmitting}>
            Annuleren
          </Button>
          <Button
            onClick={handleConfirm}
            disabled={!reason.trim() || isSubmitting}
          >
            {isSubmitting ? 'Bezig...' : 'Heropenen'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
